import { 
    apiGetUserInfo,
    apiGetBalance,
    apiWalletPayment,
    apiGetStoredRecord
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_user_balance: 'userWallet/set_user_balance',
    set_user_total_balance: 'userWallet/set_user_total_balance',
    set_user_account_info: 'userWallet/set_user_account_info',
    set_stored_record: 'userWallet/set_stored_record',
}

//未認證 1 
//資料未填2 
//資料已填但未上傳證件3
//審核中4
//正常5
//審查未通過6
//帳號停用7

const state = {
    userBalance: 0,
    userTotalBalance: 0,
    userBankAccountInfo: null,
    storeRecordList: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_USER_BALANCE: (state) => {
        return state.userBalance.toFixed(2)
    },
    GET_USER_TOTAL_BALANCE: (state) => {
        return state.userTotalBalance.toFixed(2)
    },
    GET_USER_BANK_ACCOUNT_INFO: (state) => {
        return state.userBankAccountInfo
    },
    GET_STORE_RECORD_LIST: (state) => {
        return state.storeRecordList
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getUserBalance ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            apiGetBalance()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_user_balance, res.data.result.balance)
                    commit(types.set_user_total_balance, res.data.result.totalBalance)
                    resolve()
                }else{
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getUserBankAccountInfo ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            apiGetUserInfo()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_user_account_info, res.data.result.user.bankAccountInfo)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getStoredRecord ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            apiGetStoredRecord()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_stored_record, res.data.result)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    walletPayment ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiWalletPayment(data)
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    resolve(res.data.result)
                }else{
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_user_balance](state, data){
        state.userBalance = data
    },
    [types.set_user_total_balance](state, data){
        state.userTotalBalance = data
    },
    [types.set_user_account_info](state, data){
        state.userBankAccountInfo = data
    },
    [types.set_stored_record](state, data){
        state.storeRecordList = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/userWallet.js